import { DomSanitizer } from "@angular/platform-browser";
import { Block } from "./model/block.model";


export function getSGirl(sanitizer: DomSanitizer): Block[] {
    return [
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/20221003003987.jpg",
            blockImgName: "碩達系統科學少女包場活動:地點大直美麗華影城(圖/碩達系統提供)",
            blockIndex: 0,
            blockName: "block0",
            blockType: 5,
            content: null,
            id: 1,
            imgLink: null,
            imgPosition: null,
            subtitle: null,
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 1,
            blockName: "block1",
            blockType: 3,
            content: null,
            id: 2,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin: 0px">　　九月上檔的科普電影科學少女，內容主要是述說華人世界中普遍存在已久的兩個問題: 一. 對生死議題的忌諱、二. 對於性別與能力的偏見；這兩個問題成了桎梏，影響了心理發展，也侷限了未來的可能性。</p>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/20221003004008.jpg",
            blockImgName: "20221003004008.jpg",
            blockIndex: 2,
            blockName: "block3",
            blockType: 6,
            content: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; color: black;">　　電影從回憶開始，女主角回想母親製作Orange Chocolate的步驟，為整部戲埋下了伏筆，劇中以APP開發作為借物，用食物的記憶承載思念，一步一步引領觀者一同進入她的視界；導演也巧妙的用情感做為主線，淡化生硬技術的環節，反而讓小朋友們更能專注劇情參與其中，進而啟發他們的思考與想像。<br><br>　　從「科學少女」的電影中，我們看到了另外一種可能，一種新的嘗試，試圖從下一代的教育中開始改變，屏除偏見，讓小朋友開始思考，讓大人開始學習溝通，在原有傳統教育觀念上開創一條新思路，而我們也有幸在觀影後與導演(莊景燊)、編劇(王莉雯)、監製(王銀國)訪談，更深度的瞭解電影中所想表達的意念與賦予的期待。</p>'
            ),
            id: 3,
            imgLink: null,
            imgPosition: "left",
            subtitle: null,
            title: null,
            imgInfo: "左起碩達系統技術副總蔡欣懌、執行副總吳純純、電影監製王銀國。",
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/20221003004011.jpg",
            blockImgName: "20221003004011.jpg",
            blockIndex: 3,
            blockName: "block4",
            blockType: 6,
            content: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; color: black;">　　至於為何將人工智慧與食物做連結呢? 導演表示，食物具有撫慰人心的意義，從上一輩傳承的美味，裡面有媽媽的溫度，家的味道，無論是在外的遊子、成家的大人在記憶中都可能有一道可以勾起回憶的食物，而這就是療癒的過程，如同電影一開始巧克力製作時殺青的六個步驟，經過反覆的工序，耐心與愛心，最後產出甜美難忘的獨一味道，人生也是如此。<br><br>　　「誰說女生就不擅長理工? 誰說理工腦就不能擁有感性與熱情?」，刻板印象往往會讓我們停止思考，並且找尋藉口放棄，這部電影拍攝的起心動念就是來自於監製不懈的堅持與努力，除了受到吳嘉麗及林清凉兩位教授對於女性科學教育推廣的感召，養育兩個女兒的他，也希望透過電影能破除女性不適合科學理工路的刻板印象，讓年輕學子能去探尋更多人生的可能。</p>'
            ),
            id: 4,
            imgLink: null,
            imgPosition: "right",
            subtitle: null,
            title: null,
            imgInfo: "左起編劇王莉雯、導演莊景燊。",
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 4,
            blockName: "block5",
            blockType: 3,
            content: null,
            id: 5,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin-top: 50px">　　一千個人眼裡有一千個哈姆雷特，我們都知道國片在台灣相對辛苦，導演也明白一部電影很難滿足所有的族群，監製更是頂著疫情壓力以及有限的經費預算下，義無反顧的推動這部電影的完成，無外乎是希望科學普及的理念還能再繼續，透過電影拉近距離、減少偏見、尤其是讓8-18歲青少年族群，對科學產生興趣，以及學習未來他們將面對的三個人生課題: 分離(開始與結束)、選擇(堅持對的路)、前進(改變的勇氣)。</p>'
            ),
            title: null,
            imgInfo: null,
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: "/assets/img/blog/20221003004012.jpg",
            blockImgName: "20221003004012.jpg",
            blockIndex: 5,
            blockName: "block4",
            blockType: 6,
            content: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; color: black;">　　近期碩達系統包場，大力邀約員工與親友參加，出乎意料的爆場近乎三百人出席，大多數都是家長帶著小朋友一同參與，國小、國中最多，開影前也曾擔心小朋友坐不住或者看不懂，但是沒想到，現場笑聲、讚嘆聲以及小小的啜泣聲都隨著劇情起伏演進；當面對生死的時候，再多的堅強都顯得蒼白，如同女主角的父親，也會因為面臨分離而迷惘，分開也是旅程的開始，成人如何消化悲傷也是一個重要的課題；編劇也分享，在其他場次中，有家長帶著10歲與6歲小孩觀影，不僅看得懂，而且回家後與媽媽討論起生死的問題，原本大人難以開口或者避諱的話題，忽然間似乎也沒有那麼難以言述了。</p>'
            ),
            id: 6,
            imgLink: null,
            imgPosition: "left",
            subtitle: null,
            title: null,
            imgInfo: "左起碩達系統執行長陳相宇、電影監製王銀國。",
        },
        {
            backImg: null,
            backImgName: null,
            blockImg: null,
            blockImgName: null,
            blockIndex: 6,
            blockName: "block7",
            blockType: 3,
            content: null,
            id: 7,
            imgLink: null,
            imgPosition: null,
            subtitle: sanitizer.bypassSecurityTrustHtml(
                '<p style="font-size: 20px; text-align: left; color: black; margin-top: 50px">　　碩達系統的企業精神之一就是作對的事，堅持信念，相信善的動力，以正向的力量，藉由每一次推廣與參與，在時間的長廊上留下一點感動的記憶，如果您也希望能跟小孩進一步溝通，也相信教育可以改變未來，無論是企業包場或者校園合作，歡迎帶著大朋友小朋友一同走入戲院，與我們一同探索改變世界，從現在開始!<br><br><a href="https://www.facebook.com/sgirl.film/">更多電影訊息請上科學少女FB ➡️</a></p>'
            ),
            title: null,
            imgInfo: null,
        },
    ]
}